import axios from 'axios';
export { sendDriverApplication, sendRestaurantMembershipSurveys };
// eslint-disable-next-line no-unused-vars
import { del, get, post, put, URLs } from './request';
/**
 *
 * @link https://developer.fountain.com/docs/post-apiv2applicants
 * @param {*} driver
 * @returns
 */
async function sendDriverApplication(driver) {
  const results = await axios.post('/api/int/driver-application', driver, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return results.data;
}

async function sendRestaurantMembershipSurveys(data) {
  let surverysData = {
    restaurant_name: data.restaurantName,
    restaurant_foreign_name: data.restaurantForeignName,
    phone_number: data.phoneNumber,
    amount: data.consumingAmount,
    member_point: data.memberPoint,
    next_level_amount: data.nextLevelAmount, //下一级达标金额, 可选项
    next_level_discount: data.nextLevelDiscount, //下一级达标后享受的折扣,85即85折,可选项
  };

  const results = await post({
    url: `/api/${data.locale}/v2/restaurants_membership_willingness_surveys`,
    data: surverysData,
  });
  return results.data;
}
